import { NgModule } from '@angular/core';
import { Route } from '@angular/router';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [],
})
export class ReportEditorModule {
    static defineRoute(path: string): Route {
        return {
            path,
            loadChildren: () =>
                import('app/report-editor/report-editor.lazy.module').then(
                    (m) => m.ReportEditorLazyLoadedModule,
                ),
        };
    }
}
